import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetSurveyById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("SurveySurveyQuestion/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export { GetSurveyById };
